import React, { useEffect, useState } from "react";
import SideBar from "../SideBar";
import axiosClient from "../../axios";
import { Autocomplete, TextField } from "@mui/material";
import Pagination_2 from "../Pagination_2";
import loader from "../../assets/images/loader.gif";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { dateConvert } from "../../dateConverter";
import "../../assets/css/AdminCommon.css"; // V4 Styles

const PostBack = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilterBox, setShowFilteBox] = useState(false);
  const [allProvider, setAllProvider] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [pagination, setPagination] = useState({
    page: 0,
    limit: 100
  });

  const [filterData, setFilterData] = useState({
    s_date: "",
    e_date: "",
    provider: null,
  });

  const [date, setDate] = useState({
    start: null,
    end: null,
  });

  const getAllPostBack = () => {
    if(filterData?.s_date !== "" && filterData?.e_date !== "" && filterData?.s_date > filterData.e_date){
        alert("Start Date Can Not Be Greater Than End Date...");
        return;
    }
    setShowFilteBox(false);
    setLoading(true);
    
    const requestData = {
      ...filterData,
      page: pagination.page,
      limit: pagination.limit,
      provider: filterData.provider?.id || ""
    };

    axiosClient
      .post(`/getAllPostback`, requestData)
      .then((res) => {
        console.log("data form allpostback", res);
        setData(res?.data?.response?.data || res?.data?.response);
        setTotalCount(res?.data?.response?.totalCount || res?.data?.response?.length || 0);
      })
      .catch((error) => {
        console.log("error in getting postback", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDate = (e, f) => {
    const res = dateConvert(e);
    if (f === 1) {
      setDate({ ...date, start: e });
      setFilterData({ ...filterData, s_date: res });
      return;
    }
    if (f === 2) {
      setDate({ ...date, end: e });
      setFilterData({ ...filterData, e_date: res });
      return;
    }
  };

  const getPartner = () => {
    axiosClient
      .get("/partnersList")
      .then((res) => setAllProvider(res.data.response))
      .catch((error) => console.log(error));
  };

  const clearFilters = () => {
    setFilterData({
      s_date: "",
      e_date: "",
      provider: null,
    });
    setDate({
      start: null,
      end: null,
    });
    setPagination({ ...pagination, page: 0 });
  };

  const applyFilters = () => {
    setPagination({ ...pagination, page: 0 });
    getAllPostBack();
  };

  useEffect(() => {
    getPartner();
  }, []);

  useEffect(() => {
    getAllPostBack();
  }, [pagination.page, pagination.limit]);

  return (
    <>
      <SideBar handleSideBar={true} activeTab={"AllPostBack"} />
      <div className="admin-screen-v4">
        <div className="admin-header-v4">
          <h2>All PostBack</h2>
          <div className="dFlex" style={{ gap: "16px" }}>
            <button 
              className="btn-secondary-v4"
              onClick={() => setShowFilteBox(!showFilterBox)}
            >
              {showFilterBox ? "Close" : "Filter"}
            </button>
            {showFilterBox && (
              <button 
                className="btn-secondary-v4"
                onClick={clearFilters}
              >
                Clear Filters
              </button>
            )}
          </div>
        </div>

        {showFilterBox && (
          <div className="admin-form-container-v4" style={{ marginBottom: "24px" }}>
            <div className="form-section-v4">
              <h3 className="section-header-v4">Filter Options</h3>
              <div className="form-row-v4 triple">
                <div className="form-group-v4 autocomplete-wrapper-v4">
                  <label className="form-label-v4">Provider</label>
                  <Autocomplete
                    disablePortal
                    value={filterData?.provider || null}
                    onChange={(event, newValue) => {
                      setFilterData({
                        ...filterData,
                        provider: newValue ? {
                          id: newValue._id,
                          name: newValue.name,
                        } : null,
                      });
                    }}
                    options={allProvider}
                    getOptionLabel={(option) => option?.name || ""}
                    renderInput={(params) => (
                      <TextField 
                        {...params} 
                        placeholder="Select Provider"
                        size="small"
                      />
                    )}
                  />
                </div>

                <div className="form-group-v4 date-picker-wrapper-v4">
                  <label className="form-label-v4">Start Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={date?.start}
                      onChange={(value) => handleDate(value, 1)}
                      renderInput={(params) => (
                        <TextField 
                          {...params} 
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>

                <div className="form-group-v4 date-picker-wrapper-v4">
                  <label className="form-label-v4">End Date</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={date?.end}
                      onChange={(value) => handleDate(value, 2)}
                      renderInput={(params) => (
                        <TextField 
                          {...params} 
                          size="small"
                          fullWidth
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
              </div>
              
              <div className="button-group-v4">
                <button 
                  className="cancel-button-v4"
                  onClick={() => setShowFilteBox(false)}
                >
                  Cancel
                </button>
                <button 
                  className="submit-button-v4"
                  onClick={applyFilters}
                >
                  Apply Filters
                </button>
              </div>
            </div>
          </div>
        )}

        {!loading ? (
          <div className="admin-form-container-v4">
            {data?.length > 0 && (
              <div style={{ marginTop: "var(--spacing-xl)" }}>
                <Pagination_2
                  filterDataInput={pagination}
                  setFilterDataInput={setPagination}
                  showNext={data?.length === pagination.limit}
                />
              </div>
            )}
            <div className="table-container-v4">
              {data?.length > 0 ? (
                <table className="data-table-v4">
                  <thead>
                    <tr>
                      <th>S.NO.</th>
                      <th>Conversion Id</th>
                      <th>Payout</th>
                      <th>Revenue</th>
                      <th>Status</th>
                      <th>Transaction Id</th>
                      <th>Partner Name</th>
                      <th>User Id</th>
                      <th>User Ip</th>
                      <th>Device Id</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((val, key) => (
                      <tr key={key}>
                        <td className="text-muted-v4">
                          {pagination?.page * pagination?.limit + (key + 1)}
                        </td>
                        <td className="text-mono-v4">
                          {val?.p_conversion_id || "—"}
                        </td>
                        <td className="amount-v4">
                          {val?.c_amount || "—"}
                        </td>
                        <td className="amount-v4">
                          {val?.r_amount || "—"}
                        </td>
                        <td>
                          <span className={`status-badge-v4 ${
                            val?.status === "success" ? "status-1" : 
                            val?.status === "failed" ? "status-2" : 
                            val?.status === "pending" ? "status-3" : "status-4"
                          }`}>
                            {val?.status || "—"}
                          </span>
                        </td>
                        <td className="text-mono-v4">
                          {val?.u_tx_id || "—"}
                        </td>
                        <td className="text-link-v4">
                          {val?.partner_name || "—"}
                        </td>
                        <td className="text-mono-v4">
                          {val?.user_id ? val.user_id : "—"}
                        </td>
                        <td className="text-mono-v4">
                          {val?.userIp ? val.userIp : "—"}
                        </td>
                        <td className="text-mono-v4">
                          {val?.deviceId ? val.deviceId : "—"}
                        </td>
                        <td className="text-muted-v4">
                          {val?.time ? 
                            moment.utc(val.time).local().format("DD/MM/YY, h:mm:ss a") : 
                            "—"
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="empty-state-v4">
                  <div className="empty-icon-v4">📊</div>
                  <h3>No PostBack Data Found</h3>
                  <p>Try adjusting your filters or check back later</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="loader-container-v4">
            <img src={loader} alt="Loading..." className="loader-image-v4" />
          </div>
        )}
      </div>
    </>
  );
};

export default PostBack;
